// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/vision_asset.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { GenerationCrop } from "../../generations/v1/generation_crop_pb";
import { file_vision_generations_v1_generation_crop } from "../../generations/v1/generation_crop_pb";
import type { MaskRegion } from "../../generations/v1/mask_region_pb";
import { file_vision_generations_v1_mask_region } from "../../generations/v1/mask_region_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/vision_asset.proto.
 */
export const file_vision_assets_v1_vision_asset: GenFile = /*@__PURE__*/
  fileDesc("CiN2aXNpb24vYXNzZXRzL3YxL3Zpc2lvbl9hc3NldC5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEi+QQKDFByb2plY3RJbWFnZRIQCghhc3NldF9pZBgBIAEoCRISCgpwcm9qZWN0X2lkGAIgASgJEhMKC2xvY2F0aW9uX2lkGAMgASgJEhIKCnNvcnRfb3JkZXIYBCABKAUSFAoMZnJhbWVfbnVtYmVyGAUgASgJEg8KB2NvbW1lbnQYBiABKAkSEwoLZGVzY3JpcHRpb24YByABKAkSGwoTZGlzcGxheV91c2VyX2xvY2tlZBgIIAEoCBINCgV3aWR0aBgJIAEoBRIOCgZoZWlnaHQYCiABKAUSGgoSc3RvcmFnZV9zaXplX2J5dGVzGAsgASgDEhQKDG9yaWdpbmFsX3VybBgMIAEoCRIVCg10aHVtYm5haWxfdXJsGA0gASgJEh4KFnVwbG9hZGVkX2J5X2FjY291bnRfaWQYDiABKAkSLgoKY3JlYXRlZF9hdBgPIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgQIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASHgoWc2VsZWN0ZWRfZ2VuZXJhdGlvbl9pZBgRIAEoCRIfChdnZW5lcmF0ZWRfdGh1bWJuYWlsX3VybBgSIAEoCRIcChRncmFkZWRfdGh1bWJuYWlsX3VybBgTIAEoCRI6CgRjcm9wGBQgASgLMiwucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5HZW5lcmF0aW9uQ3JvcBI+CgxtYXNrX3JlZ2lvbnMYFSADKAsyKC5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLk1hc2tSZWdpb25iBnByb3RvMw", [file_google_protobuf_timestamp, file_vision_generations_v1_generation_crop, file_vision_generations_v1_mask_region]);

/**
 * @generated from message protos.vision.assets.v1.ProjectImage
 */
export type ProjectImage = Message<"protos.vision.assets.v1.ProjectImage"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string location_id = 3;
   */
  locationId: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * @generated from field: string frame_number = 5;
   */
  frameNumber: string;

  /**
   * @generated from field: string comment = 6;
   */
  comment: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: bool display_user_locked = 8;
   */
  displayUserLocked: boolean;

  /**
   * @generated from field: int32 width = 9;
   */
  width: number;

  /**
   * @generated from field: int32 height = 10;
   */
  height: number;

  /**
   * @generated from field: int64 storage_size_bytes = 11;
   */
  storageSizeBytes: bigint;

  /**
   * @generated from field: string original_url = 12;
   */
  originalUrl: string;

  /**
   * @generated from field: string thumbnail_url = 13;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: string uploaded_by_account_id = 14;
   */
  uploadedByAccountId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string selected_generation_id = 17;
   */
  selectedGenerationId: string;

  /**
   * @generated from field: string generated_thumbnail_url = 18;
   */
  generatedThumbnailUrl: string;

  /**
   * @generated from field: string graded_thumbnail_url = 19;
   */
  gradedThumbnailUrl: string;

  /**
   * @generated from field: protos.vision.generations.v1.GenerationCrop crop = 20;
   */
  crop?: GenerationCrop | undefined;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion mask_regions = 21;
   */
  maskRegions: MaskRegion[];
};

/**
 * Describes the message protos.vision.assets.v1.ProjectImage.
 * Use `create(ProjectImageSchema)` to create a new message.
 */
export const ProjectImageSchema: GenMessage<ProjectImage> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_vision_asset, 0);

